import { inject, observer } from "mobx-react";
import React from "react";
import { theme } from "src/config";
import { Item, Tag } from "src/models";
import { TagStore } from "src/stores";
import { getTextColorFromBackgroundColor } from "src/util/util";
import styled from "styled-components";
import { Button, Icon, Spacer, Text } from "src/components";
import { useTranslation } from "react-i18next";
import { Badge } from "src/components/badge";
import { Row } from "./gridElements";
import { IItem } from "src/types";

export interface ITagsProps {
  tagStore?: TagStore;
  item:      Item<IItem>;
  onEditTags(): void;
}

export const Tags = inject("tagStore")(observer((props: ITagsProps): JSX.Element => {
  const { tagStore, onEditTags, item } = props;
  const { t, i18n }  = useTranslation();

  const tags: Tag[] = tagStore.getActiveItemTags;
  return (
    <_Row>
      <Button variant="icon" onClick={onEditTags} disabled={!item.canEdit}>
        <Badge color={theme.color.black} content={<Icon size="xxsmall" color={theme.color.white} iconId="add"/>}>
          <Icon iconId="tag" size="large" color={theme.color.black}/>
        </Badge>
      </Button>
      <Container>
        {tags.length ? 
          tags.map(t => (t && 
            <TagChip key={t.id} background={t.color || theme.color.grayDefault}>
              <Text 
                as    = "span"
                color = {getTextColorFromBackgroundColor(t.color || theme.color.grayDefault)}
              >
                #{t.title}
              </Text>
            </TagChip>
          ))
          : <Text size="small" fontStyle={"italic"}>{t("no_tags_placeholder")}</Text>
        }
      </Container>
    </_Row>
  )
}));

const _Row = styled(Row)`
  margin-top:  2rem;
  height:      fit-content;
  min-height:  fit-content;
  align-items: center;
`;


const Container = styled.div`
  display:        flex;
  flex-direction: row;
  flex-wrap:      wrap;
  width:          100%;
  min-height:     fit-content;
  padding:        0.2rem 0.5rem;
  border-bottom:  1px solid ${theme.color.secondaryBorder};

  > div:not(:last-child) {
    margin-right: 0.5rem;
  }
`;

const TagChip = styled.div<{background: string}>`
  border-radius: 4px;
  padding:       0.25rem 0.5rem;
  margin-bottom: 0.5rem;
  background:    ${props => props.background};
  height:        fit-content;
`;